import axios from "axios"
import { SAVE_DRIVE_WITH_US_URL,GET_DRIVE_WITH_US_URL,DRIVE_WITH_US_UPDATE } from "../Utils/URLs"
import { useState,useContext } from "react"
import { useNavigate } from "react-router-dom"
import {toast} from "react-toastify"
import { UserContext } from "./UserContext"

const DriveWithUsState = ()=>{
const [formBusy,setFormBusy] = useState(false)
const [response,setResponse] = useState("")
const [progress,setProgress] = useState(0)
const [loading,setLoading] = useState(true)
const [oldData,setOldData] = useState([])
const [driveWithUsData,setDriveWithUsData] = useState([])
const {setNotifications} = useContext(UserContext)

const navigate = useNavigate()
const token = localStorage.getItem("token")
    const SaveDriveWithUs =  async (data)=>{
        try{
            
            setFormBusy(true)
        const res = await axios.post(SAVE_DRIVE_WITH_US_URL,data,{
            onUploadProgress:(ProgressEvent)=>{
             const { loaded, total } = ProgressEvent;
            
                     const progressState = Math.round((loaded / total) * 100);
                     setProgress(prevProgress => {
                        if (progressState > prevProgress) {
                            return progressState;
                        }
                        return prevProgress;
                    });
                    localStorage.setItem("progress",progressState)
                     
            }  
            } )
        
        setResponse(res.data)
        setFormBusy(false)
        }catch(error){
            console.log(error)
            setFormBusy(false)
        }
    }
    const GetDriveWithUs = async()=>{
        try{
            setLoading(true)
            const res = await axios.get(GET_DRIVE_WITH_US_URL,{
                headers:{
                    Authorization:`Bearer ${token}`
                }
            })
           
            setDriveWithUsData(res.data.response)
            setOldData(res.data.oldData)
            if (res.data.notification.length !== 0) {
                res.data.notification.forEach((item) => {
                    setNotifications((prev) => {
                        if (prev) {
                            const exist = prev.find((e) => e._id === item._id);
                            
                            if (!exist) {
                                return [...prev, item];
                            }
                        } else {
                            return [item];
                        }
                        return prev;
                    });
                });
            }
            
           
            
            setLoading(false)
        }catch(error){
            console.log(error.response.data)
            if(error.response.data.msg==="token_error"){
                localStorage.clear()
                navigate("/driver_forms/login")
            }
        }
    }

    const UpdateDriveWithUs = async(data)=>{
        try{
            setFormBusy(true)
            
            const res = await axios.post(DRIVE_WITH_US_UPDATE,data,{
                headers:{
                    Authorization:`Bearer ${token}`
                }
            })
            if(res.data.type==="success"){
                toast.success(res.data.message,{
                    position:"top-right"
                })
            }
            setResponse(res.data)
            setFormBusy(false)


        }catch(error){
            console.log(error)
            if(error.response.data.msg==="token_error"){
                localStorage.clear()
                navigate("/driver_forms/login")
            }
            setFormBusy(false)
        }
    }


return{
    SaveDriveWithUs,
    formBusy,
    response,
    progress,
    GetDriveWithUs,
    loading,
    driveWithUsData,
    UpdateDriveWithUs,
    response,
    oldData

}

}

export default DriveWithUsState